require('./mortgageRequestInfo.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');

class MortgageRequestInfo extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { title, amount, message } = this.props;

        return (
            <div className="mortgage-request-info">
                <div className="mortgage-request-info__description">
                    <span className="mortgage-request-info__title">
                        {title}
                    </span>
                    <div className="mortgage-request-info__total">
                        <span className="mortgage-request-info__message">
                            {message}
                        </span>
                        <span className="mortgage-request-info__amount">
                            {amount}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestInfo.propTypes = {
    title: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    message: PropTypes.string
};

MortgageRequestInfo.defaultProps = {
    header: '',
    subtitle: ''
};

module.exports = MortgageRequestInfo;
